import { KEYWORD_LIMIT_PLANS } from './consts.mjs'
import {
  getMaxValuesForUser,
  getUserTier,
  isLimitDisabled,
  isProUser,
} from './freeVersionBlock'
import { sendMessage } from './functions'
import { PROPERTY_NAMES, PROPERTY_VALUES } from './kissmetrics'
import { MIXPANEL_PROPS } from './mixpanel'
import { trackEvent, EVENTS } from './tracking/events-tracker'
import { translate } from './translation'

export const checkoutModalHandler = ({ mixpanelProps } = {}) => {
  if (mixpanelProps) {
    trackEvent({
      event: EVENTS.PURCHASE_CLICK,
      mixpanelProperties: [
        ...mixpanelProps,
        MIXPANEL_PROPS.SOURCE.values.NEW_CHECKOUT_MODAL,
      ],
    })
  }
  sendMessage('SHOW_CHECKOUT_MODAL')
}

export const showReachedMaximumKeywordModal = ({
  kissmetricsBtnLocation,
} = {}) => {
  if ((isProUser() && getUserTier() !== 'restart') || isLimitDisabled()) {
    return
  }

  const { MAX_KEYWORDS_PER_LIST } = getMaxValuesForUser()

  sendMessage('SHOW_PROMPT', {
    title: translate('step3_reached_maximum_keyword', MAX_KEYWORDS_PER_LIST),
    message: translate('create_list_modal_limit_exceed', MAX_KEYWORDS_PER_LIST),
    eventProperty: {
      ...(kissmetricsBtnLocation && {
        [PROPERTY_NAMES.btn_location]:
          PROPERTY_VALUES[kissmetricsBtnLocation].add_to_list,
      }),
      btnLocation:
        MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.LIMIT_REACHED_MODAL,
    },
    forceUpgrade: true,
  })
}

/**
 * Displays a modal for rank tracking keyword limit.
 *
 * @param {Object} params - The parameters for displaying the modal.
 * @param {Function} params.promptModal - The function to prompt the modal.
 * @param {number} params.maxKeyword - The maximum number of keywords allowed.
 * @param {string} params.kissmetricsBtnLocation - The location of the Kissmetrics button.
 * @param {boolean} [params.isPaidUser=false] - Indicates if the user is a paid user.
 * @param {string|null} [params.addonType=null] - The type of addon, if applicable.
 * @param {string|null} [params.projectId=null] - The project ID, if applicable.
 */
export const showRankTrackingKeywordLimitModal = ({
  promptModal,
  maxKeyword,
  kissmetricsBtnLocation,
  isPaidUser = false,
  addonType = null,
  projectId = null,
}) => {
  const newMaxKeyword = KEYWORD_LIMIT_PLANS.TIER1 - maxKeyword
  promptModal(
    isPaidUser
      ? translate('keyword_limit_reached', maxKeyword)
      : translate('upgrade_to_more_keywords_heading', newMaxKeyword),
    isPaidUser
      ? translate('project_addon_cta_subheading')
      : translate('keyword_limit_reached', maxKeyword),
    {
      [PROPERTY_NAMES.btn_location]:
        PROPERTY_VALUES[kissmetricsBtnLocation]?.add_to_rank_tracking,
      btnLocation:
        MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.LIMIT_REACHED_MODAL,
    },
    true,
    null,
    false,
    addonType,
    projectId,
  )
}

export const showLocationLimitModal = ({
  promptModal,
  kissmetricsBtnLocation,
  addonType = null,
  projectId = null,
}) => {
  promptModal(
    translate('exclamation_location'),
    translate('heading_new_location'),
    {
      [PROPERTY_NAMES.btn_location]:
        PROPERTY_VALUES[kissmetricsBtnLocation].add_to_rank_tracking,
      btnLocation:
        MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.LIMIT_REACHED_MODAL,
    },
    true,
    null,
    addonType,
    projectId,
  )
}
